import React from 'react';
import NPS from "../assets/Clients/NPS.JPG";
import WakeFit from "../assets/Clients/WakeFit.JPG";
import Duroflex from "../assets/Clients/DuroFlex.JPG";
import Adityabirla from "../assets/Clients/AdityaBirla.JPG";
import Acedesigners from "../assets/Clients/AceDesigners.JPG";
import Proman from "../assets/Clients/Proman.JPG";
import Monkeybox from "../assets/Clients/MonkeyBox.JPG";
import Rswm from "../assets/Clients/Rswm.JPG";
import SportsNest from "../assets/Clients/SPortsNest.JPG"; 
import Rameshwaram from "../assets/Clients/Rameshwaram.JPG"; 

// Replace these with your actual client logos and names
const images = [
  { src: WakeFit, title: "Wake Fit" },
  { src: Duroflex, title: "Duroflex" },
  { src: Adityabirla, title: "Adityabirla" },
  { src: NPS, title: "National Public School" },
  { src: Rameshwaram, title: "Rameshwaram Cafe" },
  { src: Acedesigners, title: "Acedesigners" },
  { src: Monkeybox, title: "Monkeybox" },
  { src: Proman, title: "Proman" },
  { src: Rswm, title: "RSWM" },
  { src: SportsNest, title: "Sports Nest" },
];

function Clients() {
  return (
    <div style={{ padding: "2rem" }}>
      {/* Embedded CSS for grid and hover effect */}
      <style>{`
        .custom-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
        }
        .custom-grid-item {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.07);
          overflow: hidden;
          text-align: center;
          transition: box-shadow 0.2s;
          cursor: pointer;
        }
        .custom-grid-image-wrapper {
          overflow: hidden;
        }
       .custom-grid-image {
  width: 90%;           /* Slightly less than 100% for spacing */
  height: 140px;        /* Reduce height for less cropping */
  object-fit: contain;  /* Use 'contain' to show the whole image */
  border-radius: 10px;  /* Optional: rounded corners */
  background: #f7f7f7;  /* Optional: subtle background */
  margin: 0.5rem auto;  /* Center image horizontally */
  transition: transform 0.3s cubic-bezier(.4,2,.6,1);
  display: block;
}
.custom-grid-item:hover .custom-grid-image {
  transform: scale(1.2);
}
        .custom-grid-title {
          padding: 1rem 0;
          font-weight: 600;
          font-size: 1rem;
          color: #13499C;
          background: #f7f7f7;
        }
        @media (max-width: 600px) {
          .custom-grid-image {
            height: 120px;
          }
        }
      `}</style>

      <h2
        style={{
          textAlign: "center",
          marginBottom: "3rem",
          color: "#13499C",
          fontFamily: '"Josefin Sans", Sans-serif'
        }}
      >
        OUR PRESTIGIOUS <b>CLIENTS</b>
      </h2>

      <div className="custom-grid">
        {images.map((img, idx) => (
          <div className="custom-grid-item" key={idx}>
            <div className="custom-grid-image-wrapper">
              <img className="custom-grid-image" src={img.src} alt={img.title} />
            </div>
            <div className="custom-grid-title">{img.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Clients;
